import {currentBrowser, parseBool} from "./tools";
import moment from "moment";

export default function($app) {
	const self = this;

	const $ui = $app.require('ui');
	const $locale = $app.require('locale');

	const pixelInMinute = $app.event().moduleEpisode.pixelInMinute() || 2;
	let defaultDay = 0;
	const columnCount = Math.floor(($(window).width() - 40*2 - 50*2) / 280);

	let episodeSelect;
//	let episodeSelectTitle;
	let buttonClose;
	let daySelectContainer;
	let dayContainer;
	let sectionFilterSelect;

	function Day(dayStart) {
		const day = this;
		Day.list.push(day);

		let streamCount = 0;
		let streamPageCount = 0;
		let currentStreamPage = 0;
		let timeOffset = new Date(dayStart * 1000);
		timeOffset.setMinutes(0);
		timeOffset.setSeconds(0);
		timeOffset.setMilliseconds(0);


		this.tab = $('<li>').appendTo(daySelectContainer).text(moment.unix(dayStart).format('DD.MM'));
		this.dayContainer = $('<div>').appendTo(dayContainer).addClass('episodeSelect-daySelect-day').hide();
		this.dayContainerContent = $('<div>').appendTo(this.dayContainer).addClass('episodeSelect-daySelect-dayContent');
		this.timeContainerBox = $('<div>').appendTo(this.dayContainerContent).addClass('episodeSelect-timeLine-box');
		this.timeLine = $('<div>').appendTo(this.timeContainerBox).addClass('episodeSelect-timeLine').hide();
		this.timeContainer = $('<ul>').appendTo(this.timeContainerBox).addClass('episodeSelect-timeLine-time');
		this.episodeContainerBox = $('<div>').appendTo(this.dayContainerContent).addClass('episodeSelect-timeLine-episodeBox');
		this.episodeContainer = $('<ul>').appendTo(this.episodeContainerBox).addClass('episodeSelect-timeLine-episode');
		this.streamSliderBox = $('<div>').appendTo(this.dayContainer).addClass('episodeSelect-streamSliderBox');
		this.streamSliderLeftBox = $('<div>').appendTo(this.streamSliderBox).addClass('episodeSelect-streamSliderBox-left');
		this.streamSliderRightBox = $('<div>').appendTo(this.streamSliderBox).addClass('episodeSelect-streamSliderBox-right');

		this.streamSliderLeftBox.click(function() { day.openStreamPageLeft(); });
		this.streamSliderRightBox.click(function() { day.openStreamPageRight(); });

		this.tab.click(function() {
			day.show();
		});

		day.show = function(cb) {
			const show = function() {
				Day.current = day;
				day.tab.addClass('active');
				day.dayContainer.fadeIn(function() {
					day.scrollToCurrent();
					if(cb) { cb(); }
				});
			};
			if(Day.current) {
				Day.current.hide(function() {
					show();
				})
			} else {
				show();
			}
		};
		day.hide = function(cb) {
			day.dayContainer.fadeOut(function() {
				Day.current = null;
				day.tab.removeClass('active');
				if(cb) { cb(); }
			});
		};

		this.scrollToCurrent = function() {
			const timeLineTop = day.timeLine.position().top + day.dayContainerContent.scrollTop();
			if(timeLineTop > 0) {
				day.dayContainerContent.scrollTop(timeLineTop - $(window).height() / 2);
			} else {
				day.dayContainerContent.scrollTop(0);
			}
		};

		this.remove = function() {
			this.tab.remove();
			this.dayContainer.remove();
			return this;
		};

		this.setStreamCount = function(count) {
			streamCount = count;
			streamPageCount = Math.ceil(streamCount / columnCount);
			return this;
		};

		this.setActive = function() {
			this.tab.click();
		};

		this.openStreamPage = function(page) {
			let minPage = 0;
			let maxPage = streamPageCount - 1;
			if(page < minPage || page > maxPage) {
				return this;
			}
			page <= minPage ? this.streamSliderLeftBox.hide() : this.streamSliderLeftBox.show();
			page >= maxPage ? this.streamSliderRightBox.hide() : this.streamSliderRightBox.show();
			currentStreamPage = page;
			this.episodeContainer.animate({
				left: -this.episodeContainer.width() * page
			});
			return this;
		};
		this.openStreamPageLeft = function() {
			this.openStreamPage(currentStreamPage - 1);
			return this;
		};
		this.openStreamPageRight = function() {
			this.openStreamPage(currentStreamPage + 1);
			return this;
		};

		this.createTimeLine = function(timeStart, timeStop) {
			timeStart = new Date(timeStart * 1000);
			timeStop = new Date(timeStop * 1000);
			timeStart.setMinutes(0); timeStart.setSeconds(0); timeStart.setMilliseconds(0);
			timeStop.setMinutes(0); timeStop.setSeconds(0); timeStop.setMilliseconds(0);

			const hDiff = (timeStop - timeStart) / 1000 / 3600;
			const hStart = timeStart.getHours();
			const hStop  = hStart + hDiff + 3;
			for(let i = hStart, j = 0; i <= hStop; i++, j++) {
				$('<li>').appendTo(this.timeContainer)
					.css({height: i === hStop ? 20 : 60 * pixelInMinute})
					.append($('<div>').text((i % 24) + ':00'))
					.append($('<div>'))
					.append($('<div>').text((i % 24) + ':00'))
				;
			}
			const compareDateFormat = 'YYYY' + 'MM' + 'DD';
			if(moment(timeStart).format(compareDateFormat) === moment().format(compareDateFormat)) {
				this.timeLine.show();
				updateTimeLine();
				let timeLineTimer = setInterval(function() {
					updateTimeLine();
				}, 1000 * 60);
				setTimeout(function() {
					clearInterval(timeLineTimer);
					day.timeLine.hide();
				}, timeStop - new Date() + 1000*3600*3)
			}

			function updateTimeLine() {
				const top = (new Date() - timeStart) / 1000 / 60 * pixelInMinute;
				day.timeLine.css({top: top});
			}
		};

		this.episodeUpdate = function(episode, streamNumber) {
			return Episode.update(episode, day.episodeContainer, Math.floor(timeOffset.getTime() / 1000), streamNumber, streamCount);
		};

		Day.setCount(Day.list.length);
	}
	Day.list = [];
	Day.setCount = function(count) {
//		dayContainer.css({width: count * 100 + '%'})
//			.find('.episodeSelect-daySelect-day').css({width: 100 / count + '%'});
	};
	Day.setActive = function(number) {
		if(Day.list[number]) {
			Day.list[number].setActive();
		}
		return this;
	};
	Day.removeAll = function() {
		$.each(Day.list, function(i, day) {
			day.remove();
		});
		Day.list = [];
	};

	function Episode(episode, container, timeOffset, streamNumber, streamCount) {
		const episodeElement = this;
		const stream = episode.stream();
		//const episodeWidth = streamCount > 2 ? 33 : 50;
		const episodeWidth = Math.round(100 / (streamCount > columnCount ? columnCount : streamCount));
		const node = $('<li>')
			.appendTo(container)
			.addClass('ep' + episode.id())
			.css({
				left: ((streamNumber || 0) * episodeWidth) + '%',
				width: episodeWidth + '%'
			})
		;
		const nodeContainer = $('<div>').addClass('episode-item').appendTo(node);
		const rightContainer = $('<div>').addClass('episode-item-right-container').appendTo(nodeContainer);
		const episodeParts = {};
		['episode-time', 'episode-duration', 'episode-like', 'episode-favorite'].forEach(function(className) {
			episodeParts[className] = $('<div>').addClass(className).appendTo(rightContainer);
		});
		['episode-name', 'episode-roomName', 'episode-moderator', 'episode-speaker', 'episode-section', 'episode-description', 'episode-collapseGradient'].forEach(function(className) {
			episodeParts[className] = $('<div>').addClass(className).appendTo(nodeContainer);
		});

		episodeParts['episode-name'].click(function() {
			if(new Date(episode.timeStart() * 1000) <= Date.getServerTime()) {
				if(new Date(episode.timeStop() * 1000) >= Date.getServerTime() || stream.dvr()) {
					self.hide();
					$app.setEpisode(episode);
				}
			}
		});
		episodeParts['episode-like'].click(function() {
			$app.require('episode').like(episode, !episode.liked());
		});

		episodeParts['episode-favorite']
			.attr('title', $locale.get('episodeFavorite.addLink.title'))
			.on('click', function() {
				episode.toggleFavorite();
			});

		this.getEpisode = function() {
			return episode;
		};

		this.setName = function(name) {
			episodeParts['episode-name'].text(name);
			return this;
		};
		this.setRoomName = function(name) {
			episodeParts['episode-roomName'].text(name);
			return this;
		};
		this.setTime = function(timeStart, timeStop) {
			const top = Math.round((timeStart - timeOffset) / 60) * pixelInMinute;
			const bottom = Math.round((timeStop - timeOffset) / 60) * pixelInMinute;
			//const height = Math.round((timeStop - timeStart) / 60) * pixelInMinute - 1;
			const height = bottom - top - 1;
			episodeParts['episode-time'].text(moment.unix(timeStart).format('HH:mm') + ' - ' + moment.unix(timeStop).format('HH:mm'));
			episodeParts['episode-duration'].text(getHumanDuration(episode.duration()));

			node.css({top: top});
			nodeContainer.css({
				maxHeight: height,
				minHeight: height
			});
			return this;
		};
		this.setLikeCount = function(likeCount) {
            episodeParts['episode-like'].text(parseInt(likeCount) || 0);
			return this;
		};
		this.setLiked = function(liked) {
//			episode.liked(liked);
			liked ? node.addClass('liked') : node.removeClass('liked');
			return this;
		};
		this.setFavorite = function(isFavorite) {
			episodeParts['episode-favorite'].toggleClass('active', isFavorite);
			return this;
		};
		this.setColor = function(color) {
			nodeContainer.css('border-top-color', parseBool(color) ? '#' + color : 'transparent');
			return this;
		};
		this.setSpeaker = function(members) {
			const element = episodeParts['episode-speaker'].html('<b>' + $locale.get('episode.speaker') + ': </b>');

			if(members.length) {
				element.show();
				members.forEach(function(member, index) {
					element.append($('<span>').text(member.fullname));
					index !== members.length - 1 ? element.append(', ') : null;
				});
			} else {
				element.hide();
			}
			return this;
		};
		this.setModerator = function(members) {
			const element = episodeParts['episode-moderator'].html('<b>' + $locale.get('episode.moderator') + ': </b>');

			if(members.length) {
				element.show();
				members.forEach(function(member, index) {
					element.append($('<span>').text(member.fullname));
					index !== members.length - 1 ? element.append(', ') : null;
				});
			} else {
				element.hide();
			}
			return this;
		};
		this.setThemes = function(themes) {
			if(themes) {
				episodeParts['episode-section'].text(themes).show();
			} else {
				episodeParts['episode-section'].hide();
			}
			return this;
		};
		this.setDescription = function(description) {
			if(description) {
				episodeParts['episode-description'].html(description).show();
			} else {
				episodeParts['episode-description'].hide();
			}
			return this;
		};
		this.setStreamCount = function(streamCount) {
			node.css({width: 100 / streamCount + '%'});
			return this;
		};

		this.setAnnounce = function() {
			node
				.addClass('announceEpisode')
				.removeClass('currentEpisode')
				.removeClass('recordEpisode')
			;
			return this;
		};
		this.setCurrent = function() {
			node
				.removeClass('announceEpisode')
				.addClass('currentEpisode')
				.removeClass('recordEpisode')
			;
			return this;
		};
		this.setRecord = function() {
			node
				.removeClass('announceEpisode')
				.removeClass('currentEpisode')
				.addClass('recordEpisode')
			;
			return this;
		};
		this.setWatching = function(watching) {
			watching ? node.addClass('watching') : node.removeClass('watching');
			return this;
		};
		this.setFiltered = function(filtered) {
			filtered ? node.addClass('filtered') : node.removeClass('filtered');
			return this;
		};

		episodeElement.update = function(episode) {
			this.setName(episode.name());
			this.setTime(episode.timeStart(), episode.timeStop());
			this.setLikeCount(episode.like());
			this.setColor(episode.color());
			this.setSpeaker(episode.speakers());
			this.setModerator(episode.moderators());
			this.setThemes(episode.section());
			this.setDescription(episode.info_html());
			this.setLiked(episode.liked());
			this.setFavorite(episode.isFavorite());
			this.setRoomName(episode.stream().description());

//			this.setWatching($app.currentEpisode() == episode);

			this.updateStatus();

			episodeParts['episode-time'].toggle(!episode.isRecorded());
			episodeParts['episode-duration'].toggle(episode.isRecorded());
			episodeParts['episode-favorite'].toggle($app.require('episodeFavorite').isEnabled());

			return this;
		};

		this.updateStatus = function() {
			switch(episode.type()) {
				case 'record': episodeElement.setRecord(); break;
				case 'live': episodeElement.setCurrent(); break;
				case 'idle':
				default: episodeElement.setAnnounce();
			}
		};

		this.remove = function() {
			node.remove();
			return this;
		};

		episodeElement.update(episode);

		episode.type.subscribe(function() {
			episodeElement.updateStatus();
		});
		episode.isFavorite.subscribe(function(isFavorite) {
			episodeElement.setFavorite(isFavorite);
		});
	}
	Episode.list = {};
	Episode.find = function(episode) {
		return Episode.list[episode.id()] || null;
	};
	Episode.update = function(episode, container, timeStart, streamNumber, streamCount) {
		if(!Episode.list[episode.id()]) {
			Episode.list[episode.id()] = new Episode(episode, container, timeStart, streamNumber, streamCount);
		} else {
			Episode.list[episode.id()].update(episode);
		}
		return Episode.list[episode.id()];
	};
	Episode.removeAll = function() {
		$.each(Episode.list, function(i, episode) {
			episode.remove();
		});
		Episode.list = {};
	};

	this.show = function() {
		episodeSelect.slideDown(function() {
			Day.list[0].scrollToCurrent();
		});
	};
	this.hide = function() {
		episodeSelect.slideUp();
	};

	this.update = function() {
		let days = {};
		let sections = {};

		Episode.removeAll();
		Day.removeAll();

		$app.event().stream().forEach(function(stream) {
			stream.episode().forEach(function(episode) {
				if(episode.isDelay()) return;

				if(episode.section() && !sections[episode.section()]) {
					sections[episode.section()] = {
						name: episode.section(),
						color: episode.color()
					};
				}

				const dayKey = moment.unix(episode.timeStart()).format('MM:DD');
				if(!days[dayKey]) {
					days[dayKey] = {
						timeStart: episode.timeStart(),
						timeStop: episode.timeStop(),
						stream: [],
						episodes: []
					};
				}
				if(-1 === $.inArray(stream, days[dayKey].stream)) {
					days[dayKey].stream.push(stream);
				}
				days[dayKey].episodes.push(episode);
				days[dayKey].timeStart = Math.min(days[dayKey].timeStart, episode.timeStart());
				days[dayKey].timeStop  = Math.max(days[dayKey].timeStop,  episode.timeStop());
			});
		});

		days = $.map(days, function(v) { return v; })
			.sort(function(a, b) { return a.timeStart - b.timeStart; })
		;

		days.forEach(function(dayData) {
			const day = new Day(dayData.timeStart);
			day.createTimeLine(dayData.timeStart, dayData.timeStop);
			day.setStreamCount(dayData.stream.length);

			dayData.episodes.forEach(function(episode) {
				day.episodeUpdate(episode, dayData.stream.indexOf( episode.stream() ));
			});

			const compareDateFormat = 'YYYY' + 'MM' + 'DD';
			if(moment.unix(dayData.timeStart).format(compareDateFormat) === moment().format(compareDateFormat)) {
				defaultDay = Day.list.length - 1;
			}

			day.openStreamPage(0);
		});

		sectionFilterSelect.hide().clear();
		if(sections) {
			sectionFilterSelect.append(0, $locale.get('episode.section.filter'));
			let sectionCount = 0;
			$.each(sections, function(i, section) {
				sectionFilterSelect.append(i, section.name, '#' + section.color);
				sectionCount++;
			});
			if(sectionCount) {
				sectionFilterSelect.show();
			}
		}

		Day.setActive(defaultDay);

		return this;
	};

	this.updateEpisode = function(episode) {
		Episode.update(episode);
		return this;
	};

	this.Episode = Episode;
	this.Day = Day;

	function CustomSelect(element) {
		const self = this;
		element = $(element);
		element.addClass('customSelect');
		let titleNode = $('<div>').appendTo(element);
		let listNode = $('<ul>').appendTo(element);
		let items = {};
		let current = null;
		let listeners = [];

		self.open = function() {
			listNode.slideDown(function() {
				element.addClass('active');
			});
			return self;
		};
		self.close = function() {
			listNode.slideUp(function() {
				element.removeClass('active');
			});
			return self;
		};

		titleNode.click(function() {
			if(element.hasClass('active')) {
				self.close();
			} else {
				self.open();
			}
		});

		function setCurrent(value, title, color) {
			current = value;
			titleNode.text(title);
			titleNode.css({backgroundColor: color || ''});
		}
		function sendChange() {
			$.each(listeners, function(i, cb) {
				cb.call(self, current);
			});
		}

		self.val = function(value) {
			if(typeof value === 'undefined') {
			} else {
				return current;
			}
		};
		self.append = function(value, title, color) {
			if(typeof title === 'undefined') {
				title = value;
			}
			items[value] = $('<li>').appendTo(listNode)
				.append($('<span>').addClass('color').css({backgroundColor: color || ''}))
				.append($('<span>').text(title))
				.click(function() {
					setCurrent(value, title, color);
					self.close();
					sendChange();
				})
			;
			if(current === null) {
				setCurrent(value, title, color);
			}
			return self;
		};
		self.clear = function() {
			items = {};
			listNode.children().remove();
			setCurrent(null, null, null);
			return self;
		};
		self.hide = function() {
			element.hide();
			return self;
		};
		self.show = function() {
			element.show();
			return self;
		};
		self.change = function(cb) {
			listeners.push(cb);
			return self;
		}
	}

	this.init = function() {
		episodeSelect = $('#episodeSelect');
//		episodeSelectTitle = episodeSelect.find('.episodeSelect-header-title');
		buttonClose = episodeSelect.find('.episodeSelect-closeButton');
		daySelectContainer = episodeSelect.find('.episodeSelect-daySelect ul');
		dayContainer = episodeSelect.find('.episodeSelect-daySelect-layout');
		sectionFilterSelect = new CustomSelect(episodeSelect.find('.episodeSelect-header-filter .sectionFilter'));

//		episodeSelectTitle.text($app.event().name());

		buttonClose.click(function() {
			self.hide();
		});

		sectionFilterSelect.change(function(value) {
			if(value) {
				$.each(Episode.list, function(i, episode) {
					episode.setFiltered(episode.getEpisode().section() !== value);
				});
			} else {
				$.each(Episode.list, function(i, episode) {
					episode.setFiltered(false);
				});
			}
		});

		$('.showEpisodeSelectButton').click(function() {
			self.show();
			if(Day.current) {
				Day.current.scrollToCurrent();
			}
		});

		if($app.event().stream().length > 1 && $app.event().episode().length && !$app.event().moduleEpisode.showTable() && !currentBrowser.isMobile() && $app.event().moduleEpisode.position() !== 'hide') {
			self.uiButton = new $ui.Button({
				position: $app.event().moduleEpisode.position,
				icon: 'table',
				title: $locale.get('episodeSelect.button.title'),
                isShowTitle: true,
			});
			self.uiButton.on('click', function() { self.show(); });
			setTimeout(function() { self.uiButton.showHint(); }, 2*1000);
			setTimeout(function() { self.uiButton.hideHint(); }, 12*1000);

			$(window).on('keyup', function(event) {
				if(27 === event.which) {
					self.hide();
				}
			});
		}

		$app.currentEpisode.subscribe(function(currentEpisode) {
			const container = $('#episodeSelect');
			container.find('.watching').removeClass('watching');
			if(currentEpisode) {
				container.find('.ep' + currentEpisode.id()).addClass('watching');
			}
		});
	};

	$app.on('start', function() {
		$app.log('Начало генерации расписания');
		self.init();
		self.update();
		$app.log('Генерация расписания закончена');
	});

	$app.require('comet')
		.on('create:episode', () => setTimeout(() => self.update(), 0))
		.on('update:episode', () => setTimeout(() => self.update(), 0))
		.on('delete:episode', () => setTimeout(() => self.update(), 0))
		.on('update:episode/like', () => setTimeout(() => self.update(), 0))
	;

	$app.on('currentEpisode', function(episode, lastEpisode) {
		if(lastEpisode) {
//			self.updateEpisode(lastEpisode);
		}
		if(episode) {
//			self.updateEpisode(episode);
		}
	});

};
